import React, { useContext } from 'react';
import FilterInput from '../../../components/filter-input';

import { id } from '../../../../filters/options/recipient-name';
import { AdvancedSearchShipmentContext } from '../../context';
import messages from '../messages';

const RecipientFilter = () => {
  const { filters, updateFilter } = useContext(AdvancedSearchShipmentContext);

  return <FilterInput filters={filters} id={id} labelMessage={messages.recipient} updateFilter={updateFilter} />;
};

export default RecipientFilter;
